import { ComponentType, MemoExoticComponent } from 'react';
import { RegistrationFieldProps } from '../RegistrationField.types';
import { RegistrationData } from '../../../state/registrationForm/registrationForm.types';
import GenderField from './GenderField/GenderField';
import IndustriesField from './IndustriesField/IndustriesField';
import BirthDateField from './BirthDayField/BirthDayField';
import LimitsField from './LimitsField/LimitsField';
import PhoneField from './PhoneField/PhoneField';
import CheckboxField from './CheckBoxField/CheckBoxField';
import OccupationField from './OccupationField/OccupationField';
import TermsField from './TermsField/TermsField';
import AddressField from './AddressField/AddressField';
import OfferField from './OfferField/OfferField';

type FieldComponentMap = {
  [K in keyof RegistrationData]:
    | ComponentType<RegistrationFieldProps<K>>
    | MemoExoticComponent<ComponentType<RegistrationFieldProps<K>>>;
};

const customComponents: Partial<FieldComponentMap> = {
  gender: GenderField,
  address: AddressField,
  birthDate: BirthDateField,
  industry: IndustriesField,
  occupation: OccupationField,
  marketing: CheckboxField,
  age: CheckboxField,
  pep: CheckboxField,
  fit: CheckboxField,
  limits: LimitsField,
  promoId: OfferField,
  phone: PhoneField,
  terms: TermsField,
};

export default customComponents;
